import DialogNg from '@jetbrains/ring-ui/components/dialog-ng/dialog-ng';
import template from './ssl-certificate.html';

export default angular.module('installer.components.ssl-confirm', [DialogNg]).
  factory('sslCertificateDialog', ($q, dialog, installerResource) => options => {

    options.untrustedCertificate = options.untrustedCertificate.reverse();
    const hostCertificate = options.untrustedCertificate[0];
    const hostIsSelfSigned = hostCertificate.subject === hostCertificate.issuer && options.untrustedCertificate.length === 1;

    const defer = $q.defer();
    const isFirstChainCertificateTrusted = options.isFirstChainCertificateTrusted;
    const isOnlySelfSigned = options.untrustedCertificate.length === 1 && hostIsSelfSigned;

    let dialogData = {
      uploadError: []
    };

    function trustAll() {
      dialogData.uploadError = [];
      dialogData.isBusy = true;

      let success = true;
      const uploadPromises = options.untrustedCertificate.map(cert => installerResource.hubCertificateUpload.save({
        base64Der: cert.base64Der
      }).$promise.catch(err => {
        success = false;
        dialogData.uploadError.push(installerResource.extractErrorMessage(err.data) || err.data);
      }));

      return $q.all(uploadPromises).then(res => {
        if (success) {
          dialog.hide();
          defer.resolve(res);
        }
        dialogData.isBusy = false;
      });
    }

    function uploadCert(certContent) {
      dialogData.uploadError = [];
      dialogData.isBusy = true;

      return installerResource.hubCertificateUpload.save({
        base64Der: certContent
      }).$promise.
        then(res => {
          dialog.hide();
          defer.resolve(res);
        }).
        catch(err => {
          dialogData.uploadError.push(installerResource.extractErrorMessage(err.data) || err.data);
        }).
        finally(() => {
          dialogData.isBusy = false;
        });
    }

    dialogData = {
      options,
      isFirstChainCertificateTrusted,
      hostIsSelfSigned,
      isOnlySelfSigned,

      isExpired: cert => Date.now() > cert.validBefore,
      notYetValid: cert => Date.now() < cert.validAfter,
      isSelfSigned: cert => cert.issuer === cert.subject,

      getSpacing: $index => `${($index + 1) * 16 }px`,
      trustKnownChain: () => trustAll(),
      cancelDialog: () => dialog.hide() || defer.reject(),
      uploadCustomCertificate: fileBase64Content => uploadCert(fileBase64Content)
    };

    dialog.show({
      title: 'SSL certificate',
      template,
      wideDialog: true,
      data: dialogData,
      buttons: null
    });

    return defer.promise;
  });



// WEBPACK FOOTER //
// ./src/blocks/ssl-certificate/ssl-certificate.js